import { render, staticRenderFns } from "./boardLoader.vue?vue&type=template&id=47d26462"
import script from "./boardLoader.vue?vue&type=script&lang=js"
export * from "./boardLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports